'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleAnalytics = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleAnalytics, _SvgIcon);

  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);

    return _possibleConstructorReturn(this, (GoogleAnalytics.__proto__ || Object.getPrototypeOf(GoogleAnalytics)).apply(this, arguments));
  }

  _createClass(GoogleAnalytics, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'gmail', transform: 'translate(6.000000, 12.000000)' },
            _react2['default'].createElement(
              'linearGradient',
              {
                id: 'linear-gradient',
                x1: '17.9921433%',
                y1: '49.9999992%',
                x2: '81.886266%',
                y2: '49.9999992%'
              },
              _react2['default'].createElement('stop', { offset: '0%', stopColor: '#F7F6EF' }),
              _react2['default'].createElement('stop', { offset: '100%', stopColor: '#E6E4D6' })
            ),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(0.000000, 18.670900)' },
              _react2['default'].createElement('polygon', {
                id: 'Fill-10',
                fill: '#000000',
                mask: 'url(#mask-9)',
                points: '0.0151794882 14.6007795 20.5435565 0.0859313639 20.4506317 0.0190865268 0.0151794882 14.2817591'
              })
            ),
            _react2['default'].createElement('path', {
              fill: '#E75A4D',
              transform: 'translate(0.000000, 0.015721)',
              d: 'M48.6316493,0.00578001104 C51.0186625,0.00578001104 52.9718004,1.9905376 52.9718004,4.41624716 L52.9718004,5.69482695 L46.9419644,10.0718717 L26.4135873,24.4420903 L5.88523147,9.92610083 L5.88523147,38.9569385 L4.34013631,38.9569385 C1.9531443,38.9569385 6.35745702e-06,36.972224 6.35745702e-06,34.5465144 L6.35745702e-06,4.41745312 C6.35745702e-06,1.99172203 1.9531443,0.00696443954 4.34013631,0.00696443954 L26.4136085,16.6379987 L48.6304414,0.00696443954 L48.6316493,0.00578001104 Z'
            }),
            _react2['default'].createElement('polygon', {
              fill: 'url(#linear-gradient)',
              transform: 'translate(4.323071, 0.015721)',
              points: '0.0170803679 0.00577139702 22.0905314 16.6368056 44.3085722 0.00577139702'
            }),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(0.000000, 4.220872)' },
              _react2['default'].createElement('polygon', {
                fill: '#E7E4D7',
                transform: 'translate(5.870052, 5.700977)',
                points: '0.0151794882 0.0199651574 0.0151794882 29.0508028 41.0730567 29.0508028 41.0730567 0.165736002 20.5435565 14.5359547'
              })
            ),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(5.870052, 24.100977)' },
              _react2['default'].createElement('polygon', {
                fill: '#B8B7AE',
                points: '0.0151794882 14.6007795 20.5435565 0.0859313639 20.4506317 0.0190865268 0.0151794882 14.2817591'
              })
            ),
            _react2['default'].createElement(
              'g',
              { transform: 'translate(20.534586, 4.371618)' },
              _react2['default'].createElement('polygon', {
                fill: '#B7B6AD',
                transform: 'translate(5.870052, 5.700977)',
                points: '20.5384769 0.0149927112 20.5502382 28.9000595 0.00895553778 14.3852114'
              })
            ),
            _react2['default'].createElement('path', {
              fill: '#B2392F',
              transform: 'translate(5.734586, 5.571618)',
              d: 'M47.10174,0.00957664274 L47.1087968,28.8647959 C47.0053397,32.0720129 45.6378084,33.2167522 41.0848096,33.2705253 L41.0730906,4.38543694 L47.1029267,0.00839221425 L47.1017612,0.00957664274 L47.10174,0.00957664274 Z'
            }),
            _react2['default'].createElement('polygon', {
              fill: '#F7F5ED',
              points: '4.34014266 0.0215006074 26.4135937 16.6525133 48.6316557 0.0215006074'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return GoogleAnalytics;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = GoogleAnalytics;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Gmail.js
// module id = 1370
// module chunks = 32